module.exports = __webpack_public_path__ + "img/NP.0336895b.svg";